import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider } from 'semantic-ui-react';
import _ from 'lodash';

import { SingleSelect } from '../Select';
import { DeleteBtn, PlusBtn } from '../../../Buttons';
import { AddableEmptyMessage } from '../EmptyMessage';

import ErrorMessage from '../ErrorMessage';
import Required from '../Required';

export class AddableSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: props.elements || [],
      options: props.options || [],
      usefulOptions: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.options.length === 0 && nextProps.options.length > 0) {
      this.setState({
        options: nextProps.options,
      }, this.filterOptions);
    }
  }

  onInputDelete = (item) => {
    const items = _.cloneDeep(this.state.items);
    _.remove(items, (i) => i.value === item.value);
    this.setState({
      items,
    }, this.filterOptions);

    this.props.onChange(this.props.type, items);
  }

  onChangeSelect = (data, item) => {
    const items = _.cloneDeep(this.state.items);
    const itemIndex = _.findIndex(items, { key: item.key });
    const itemData = {
      ...item,
      ...data,
    };
    items.splice(itemIndex, 1, itemData);

    this.setState({
      items,
    }, this.filterOptions);

    this.props.onChange(this.props.type, items);
  }

  filterOptions = () => {
    const usefulOptions = _.differenceBy(this.state.options, this.state.items, 'value');
    this.setState({
      usefulOptions,
    });
  }

  renderInput = (e) => {
    e.preventDefault();
    const items = _.cloneDeep(this.state.items);
    items.unshift({
      value: '',
      label: '',
      key: Date.now(),
    });
    this.setState({ items });
  }

  render() {
    const selectGridStyle = {
      textAlign: 'left',
    };

    return (
      <div>
        <Grid>
          <Grid.Column width={16}>
            <Divider horizontal style={{ marginBottom: 5 }}>{this.props.label}<Required required={this.props.required} /><PlusBtn action={this.renderInput} /></Divider>
          </Grid.Column>
          {this.props.touched[this.props.type] && this.props.errors[this.props.type] && <Grid.Column width={16} style={{ marginTop: -15 }}><ErrorMessage centered>{this.props.errors[this.props.type]}</ErrorMessage></Grid.Column>}
          {(!this.state.items || this.state.items.length === 0) && <Grid.Column width={16} style={{ marginTop: -15, marginBottom: 15 }}> <AddableEmptyMessage /></Grid.Column>}
        </Grid>
        {this.state.items.map((item) => (
          <Grid key={item.key} style={{ marginTop: 0, marginBottom: 0 }}>
            <Grid.Column
              style={selectGridStyle}
              width={14}
            >
              <SingleSelect
                options={this.state.usefulOptions}
                value={item.value ? { ...item } : null}
                onChange={(e, data) => this.onChangeSelect(data, item)}
                onBlur={() => {}}
              />
            </Grid.Column>
            <Grid.Column width={2} textAlign="center">
              <DeleteBtn action={() => this.onInputDelete(item)} />
            </Grid.Column>
          </Grid>
        ))}
      </div>
    );
  }
}

AddableSelect.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  elements: PropTypes.array,
  onChange: PropTypes.func,
  options: PropTypes.array,
  required: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
};



// WEBPACK FOOTER //
// ./app/components/Forms/UI/AddableSelect/index.js